import { Button, Form, Input } from "antd";
import { login } from "../../Service/AuthService";
import * as FeatureFlags from "../../Service/FeatureFlags";
import ResetPasswordModal from "./ResetPasswordModal";
import React, { useState } from "react";
import { FormInstance } from "antd/lib/form";

interface LoginFormProps {
  originalLocation?: any;
  setError: Function;
}

const layout = {
  labelCol: { span: 2 },
  wrapperCol: { span: 8 },
};

const tailLayout = {
  wrapperCol: { offset: 2, span: 8 },
};

const formRef: React.RefObject<FormInstance> = React.createRef();

export default function LoginForm(props: LoginFormProps) {
  const { originalLocation, setError } = props;
  const [loading, setLoading] = useState(false);

  const onRequestSuccess = () => {
    setLoading(false);
    const redirectPath = originalLocation?.search !== ''
      ? new URLSearchParams(originalLocation?.search.substring(1)).get('location')
      : '/';
    window.location.href = redirectPath ? redirectPath : '/';
  };

  const onRequestError = (error: any) => {
    setLoading(false);
    setError(error);
  }

  return (
    <Form
      {...layout}
      ref={formRef}
      onFinish={(values: any) => {
        setLoading(true);
        login(
          values.email,
          values.password,
          {
            successCallback: onRequestSuccess,
            errorCallback: onRequestError
          }
        )
      }}
    >
      <Form.Item label="Email" name="email" rules={[{
        required: true,
        message: 'Please input your email!'
      }]}>
        <Input/>
      </Form.Item>

      <Form.Item label="Password" rules={[{
        required: true,
        message: 'Please input your password!'
      }]}>
        <Form.Item name="password">
          <Input.Password/>
        </Form.Item>
        {FeatureFlags.getFeatureFlag('resetPassword')
          ? <ResetPasswordModal />
          : <></>
        }
      </Form.Item>

      <Form.Item {...tailLayout}>
        <Button type="primary" htmlType="submit" loading={loading}>
          Submit
        </Button>
      </Form.Item>
    </Form>
  );
}